// ---------------------------------------------
// Cart Module - DeSight Shopify Theme
// ---------------------------------------------
// Cart-Funktionalität
// Dawn hat bereits umfangreiche Cart-Funktionen
// Hier nur zusätzliche Custom-Funktionen
// ---------------------------------------------

import { CartAPI } from '../utils/api.js';
import { $, $$ } from '../utils/helpers.js';

/**
 * Custom Cart Funktionen
 */
export class CustomCart {
  constructor() {
    this.init();
  }

  init() {
    console.log('Custom Cart initialized');
    // Hier können zusätzliche Cart-Initialisierungen vorgenommen werden
  }

  /**
   * Zeigt Cart-Anzahl an
   */
  async updateCartCount() {
    try {
      const cart = await CartAPI.get();
      const cartCountElements = $$('[data-cart-count]');
      
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
      });
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }
}

